"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../../helpers");
const types_1 = require("../types");
function propsAdapter(props) {
    var _a, _b;
    const headerHeight = parseInt(String(props.headerHeight || helpers_1.SPACING_XXL), 10) + 2;
    const rowHeight = parseInt(String(props.rowHeight || helpers_1.SPACING_XL), 10);
    const defaultColumnWidth = parseInt(String(props.defaultColumnWidth || 200), 10);
    const initialScrollTop = props.initialScrollTop || 0;
    return {
        data: props.data,
        columnsList: props.columns,
        heightInit: props.height,
        headerHeight,
        defaultColumnWidth,
        children: props.children,
        selection: props.selection,
        sort: props.sort,
        pagination: props.pagination,
        notification: Object.assign({}, props.notification, {
            position: (_b = (_a = props.notification) === null || _a === void 0 ? void 0 : _a.position) !== null && _b !== void 0 ? _b : types_1.GRID_NOTIFICATION_POSITION.overlay
        }),
        totalRow: props.totalRow,
        disabled: props.disabled,
        rowHeight,
        isLoading: props.isLoading,
        hideHeader: props.hideHeader,
        toggleable: props.toggleable,
        resizable: props.resizable,
        initialScrollTop,
        onRowClick: props.onRowClick,
        onRowDoubleClick: props.onRowDoubleClick,
        onRowContextMenu: props.onRowContextMenu,
        onSelectionChange: props.onSelectionChange,
        onHeaderSelectionChange: props.onHeaderSelectionChange,
        onScroll: props.onScroll,
        onColumnToggle: props.onColumnToggle,
        onColumnResize: props.onColumnResize
    };
}
exports.default = propsAdapter;
//# sourceMappingURL=propsAdapter.js.map